import { makeStyles } from '@mui/styles';
import { STYLE } from 'constants/style';

export const useStyles = makeStyles((theme: any) => ({
  container: {
    padding: theme.spacing(3),
    paddingTop: '103px',
    maxWidth: '1200px',
    margin: '0 auto',
    minHeight: '100vh',
    backgroundColor: STYLE.COLOR.WHITE,
    '@media (max-width: 1024px)': {
      paddingTop: '100px',
      maxWidth: '100%',
      padding: theme.spacing(2),
    },
    '@media (max-width: 768px)': {
      paddingTop: '90px',
      padding: theme.spacing(2, 1.5),
      paddingBottom: '45px',
    },
    '@media (max-width: 600px)': {
      paddingTop: '80px',
      paddingBottom: '45px',
    },
    '@media (max-width: 480px)': {
      padding: theme.spacing(1.5, 1),
      paddingTop: '90px',
      paddingBottom: '45px',
    },
  },
  containerWithWarning: {
    paddingTop: '143px',
    '@media (max-width: 1024px)': {
      paddingTop: '140px',
    },
    '@media (max-width: 768px)': {
      paddingTop: '130px',
    },
    '@media (max-width: 600px)': {
      paddingTop: '120px',
    },
    '@media (max-width: 480px)': {
      paddingTop: '130px',
    },
  },
  mainHeader: { left: 0 },

  // Header styles
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(4),
    '@media (max-width: 768px)': {
      marginBottom: theme.spacing(3),
    },
  },
  title: {
    fontWeight: 600,
    color: STYLE.COLOR.BLACK,
    fontSize: '32px',
    lineHeight: '39px',
    '@media (max-width: 768px)': {
      fontSize: '24px',
      lineHeight: '30px',
    },
    '@media (max-width: 480px)': {
      fontSize: '16px',
      lineHeight: '24px',
    },
  },
  headerActions: {
    display: 'flex',
    gap: theme.spacing(2),
    '@media (max-width: 768px)': {
      width: '100%',
      justifyContent: 'flex-start',
    },
    '@media (max-width: 480px)': {
      gap: theme.spacing(1.5),
    },
  },
  actionButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
  },
  actionButton: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px',
    textDecoration: 'underline',
    color: STYLE.COLOR.ACCENT_PRIMARY,
    cursor: 'pointer',
  },

  // Tabs styles
  tabsContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '32px',
    gap: theme.spacing(2),
    '@media (max-width: 960px)': {
      marginBottom: theme.spacing(3),
    },
  },
  tabs: {
    borderBottom: '0px' + '!important',
    '& .MuiTab-root': {
      textTransform: 'none',
      fontSize: '16px',
      fontWeight: 400,
      lineHeight: '24px',
      color: STYLE.COLOR.TEXT1,
      '&.Mui-selected': {
        backgroundColor: STYLE.COLOR.ACCENT_PRIMARY,
        color: STYLE.COLOR.WHITE,
        '& .custom-count-badge': {
          backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
          color: STYLE.COLOR.ACCENT_PRIMARY,
        },
      },
      '@media (max-width: 768px)': {
        fontSize: '14px',
        minWidth: 'auto',
        padding: theme.spacing(1, 1.5),
      },
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
    '@media (max-width: 768px)': {
      width: '100%',
      '& .MuiTabs-flexContainer': {
        justifyContent: 'flex-start',
      },
    },
    '@media (max-width: 480px)': {
      overflowX: 'auto',
      '& .MuiTabs-scroller': {
        overflowX: 'auto !important',
      },
    },
  },
  tab: {
    border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}` + '!important',
    borderRadius: '8px !important',
    marginRight: '16px' + '!important',
    '@media (max-width: 768px)': {
      marginRight: '8px' + '!important',
    },
    '@media (max-width: 480px)': {
      marginRight: '6px' + '!important',
    },
  },
  customTabLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  customCountBadge: {
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    borderRadius: '50%',
    minWidth: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: 1,
  },
  actionButtons: {
    display: 'flex',
    gap: theme.spacing(2),
    alignItems: 'center',
    '@media (max-width: 768px)': {
      gap: theme.spacing(1),
    },
  },
  addButton: {
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY + '!important',
    color: STYLE.COLOR.WHITE + '!important',
    borderRadius: '52px' + '!important',
    padding: '16px 20px' + '!important',
    fontSize: '14px' + '!important',
    fontWeight: 500 + '!important',
    lineHeight: '24px' + '!important',
    textTransform: 'none' as const,
    position: 'relative',
    display: 'flex',
    whiteSpace: 'nowrap',
    '@media (max-width: 960px)': {
      justifyContent: 'center !important',
      minWidth: '52px !important',
      borderRadius: '12px' + '!important',
      padding: '0 !important',
      '& svg': {
        margin: 0 + '!important',
      },
    },
    '@media (max-width: 480px)': {
      height: '44px !important',
      width: '44px !important',
      minWidth: '44px !important',
      borderRadius: '12px' + '!important',
    },
  },
  sortButton: {
    border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}` + '!important',
    borderRadius: '52px' + '!important',
    padding: '14px 24px' + '!important',
    fontSize: '16px' + '!important',
    fontWeight: 400 + '!important',
    lineHeight: '24px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    display: 'flex' + '!important',
    alignItems: 'center' + '!important',
    flexShrink: 0 + '!important',
    '@media (max-width: 960px)': {
      justifyContent: 'center !important',
      minWidth: '52px !important',
      padding: '0 !important',
      borderRadius: '12px' + '!important',
      '& svg': {
        margin: 0 + '!important',
      },
    },
    '@media (max-width: 480px)': {
      height: '44px !important',
      width: '44px !important',
      minWidth: '44px !important',
      borderRadius: '12px' + '!important',
    },
  },
  filterButton: {
    border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}` + '!important',
    borderRadius: '52px' + '!important',
    padding: '14px 24px' + '!important',
    fontSize: '16px' + '!important',
    fontWeight: 400 + '!important',
    lineHeight: '24px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    display: 'flex' + '!important',
    alignItems: 'center' + '!important',
    flexShrink: 0 + '!important',
    '@media (max-width: 960px)': {
      justifyContent: 'center !important',
      minWidth: '52px !important',
      padding: '0 !important',
      borderRadius: '12px' + '!important',
      '& svg': {
        margin: 0 + '!important',
      },
    },
    '@media (max-width: 480px)': {
      height: '44px !important',
      width: '44px !important',
      minWidth: '44px !important',
      borderRadius: '12px' + '!important',
    },
  },

  // Certifications grid
  certificationsGrid: {
    marginTop: theme.spacing(2),
    '@media (max-width: 768px)': {
      marginTop: theme.spacing(1.5),
    },
  },

  // Certification card styles
  certificationCard: {
    opacity: 1,
    gap: '16px',
    borderRadius: '12px' + '!important',
    borderWidth: '1px',
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    boxShadow: '0 16px 20px -8px rgba(228, 231, 233, 0.40)' + '!important',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  // Required Certificate Card styles
  requiredCertificateCard: {
    opacity: 1,
    borderRadius: '12px' + '!important',
    borderWidth: '1px',
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    boxShadow: '0 16px 20px -8px rgba(228, 231, 233, 0.40)' + '!important',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: '16px',
    '@media (max-width: 480px)': {
      padding: theme.spacing(1.5),
      gap: '12px',
    },
  },
  requiredCardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
  },
  requiredBanner: {
    background: STYLE.COLOR.WARNING_NOTE,
    padding: '8px 12px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
  },
  requiredBannerText: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: STYLE.COLOR.TEXT1,
    margin: 0,
  },
  certificateSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  uploadedLabel: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: STYLE.COLOR.SUCCESS,
    margin: 0,
  },
  pendingLabel: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: STYLE.COLOR.ERROR,
    margin: 0,
  },
  projectNameLabel: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: STYLE.COLOR.TEXT2,
    margin: 0,
  },
  certificateList: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    margin: 0,
  },
  projectNameText: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    margin: 0,
  },
  addCertificateButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    padding: '12px 16px',
    background: STYLE.COLOR.WHITE,
    border: `1px solid ${STYLE.COLOR.BUTTON_OUTLINED_DISABLED}`,
    borderRadius: '100px',
    cursor: 'pointer',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.BUTTON_OUTLINED_DISABLED,
    transition: 'all 0.2s ease',
  },
  // New Required Certificate Card styles
  projectHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    marginBottom: '8px',
  },
  projectAvatar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    background: STYLE.COLOR.WARNING_LIGHT,
    borderRadius: '50%',
    fontSize: '18px',
    fontWeight: 600,
    color: STYLE.COLOR.TEXT4,
    flexShrink: 0,
  },
  projectTitle: {
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '24px',
    color: STYLE.COLOR.TEXT1,
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  certificationGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
  groupLabel: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: STYLE.COLOR.TEXT2,
    margin: 0,
  },
  groupContent: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    margin: 0,
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  cardActions: {
    display: 'flex',
    gap: '12px',
    marginTop: 'auto',
    '@media (max-width: 480px)': {
      flexDirection: 'column',
      gap: '8px',
    },
  },
  requiredButton: {
    flex: '1 !important',
    padding: '12px 16px !important',
    '@media (max-width: 480px)': {
      flex: 'unset !important',
      width: '100% !important',
    },
  },
  // Expired Certificate Card styles
  expiredCertificateCard: {
    opacity: 1,
    borderRadius: '12px' + '!important',
    borderWidth: '1px',
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    boxShadow: '0 16px 20px -8px rgba(228, 231, 233, 0.40)' + '!important',
    padding: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: '16px',
    background: STYLE.COLOR.INPUT_BACKGROUND,
  },
  expiredCardHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    width: '100%',
  },
  expiredDateValue: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.ERROR,
    wordBreak: 'break-word',
  },
  uploadNewButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '12px 16px',
    background: STYLE.COLOR.WHITE,
    border: `1px solid ${STYLE.COLOR.BUTTON_OUTLINED_DISABLED}`,
    borderRadius: '100px',
    cursor: 'pointer',
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.BUTTON_OUTLINED_DISABLED,
    transition: 'all 0.2s ease',
    '&:hover': {
      background: STYLE.COLOR.WHITE,
      border: `1px solid ${STYLE.COLOR.BUTTON_OUTLINED_DISABLED}`,
      color: STYLE.COLOR.BUTTON_OUTLINED_DISABLED,
    },
  },
  certificationHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: '16px',
    width: '100%',
  },
  certificateHeaderContent: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    flex: 1,
    minWidth: 0,
  },
  certificationAvatar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    background: STYLE.COLOR.WARNING_LIGHT,
    borderRadius: '50%',
    fontSize: '18px',
    fontWeight: 600,
    color: STYLE.COLOR.TEXT4,
    marginRight: '2px',
    flexShrink: 0,
  },
  certificationInfo: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
    gap: '2px',
  },
  certificationName: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '21px',
    color: STYLE.COLOR.TEXT1,
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginRight: '16px',
  },
  certificationDate: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: STYLE.COLOR.TEXT2,
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  menuButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: '4px',
    borderRadius: '4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'background-color 0.2s ease',
    flexShrink: 0,
    width: '24px',
    height: '24px',
  },
  certificationDetails: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  detailRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
  },
  certificateDates: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
  },
  dateItem: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    minWidth: 0,
  },
  detailLabel: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
    color: STYLE.COLOR.TEXT2,
  },
  detailValue: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    wordBreak: 'break-word',
  },
  detailValueClamp: {
    fontWeight: 500,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    wordBreak: 'break-word',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  projectsRequired: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    paddingTop: '16px',
    borderTop: `1px dashed ${STYLE.COLOR.TABS_BORDER}`,
    marginTop: '4px',
  },
  projectsLabel: {
    color: STYLE.COLOR.TEXT2,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px',
    fontFamily: 'Poppins',
    margin: 0,
  },
  projectsText: {
    color: STYLE.COLOR.TEXT1,
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px',
    fontFamily: 'Poppins',
    margin: 0,
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
  },

  // Actions Menu styles
  actionsMenu: {
    position: 'fixed',
    background: STYLE.COLOR.WHITE,
    border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    borderRadius: '12px',
    boxShadow: '0px 4px 20px rgba(0, 58, 87, 0.05)',
    zIndex: 1000,
    minWidth: '102px',
    overflow: 'hidden',
  },
  actionsMenuItem: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    padding: '8px 20px',
    background: 'none',
    border: 'none',
    borderBottom: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
    textAlign: 'left',
    cursor: 'pointer',
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '20px',
    color: STYLE.COLOR.TEXT1,
    transition: 'background-color 0.2s ease',
    '&:hover': {
      background: STYLE.COLOR.BACKGROUND_LIGHT,
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  },

  // Context Menu styles
  contextMenu: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: `1px solid ${STYLE.COLOR.TABS_BORDER}`,
      borderRadius: theme.spacing(1),
      minWidth: '200px',
      padding: '0px 12px',
    },
  },
  sortMenu: {
    '& .MuiPaper-root': {
      boxShadow: 'none',
      border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}`,
      borderRadius: theme.spacing(1),
      minWidth: '200px',
      padding: '0px 12px',
      marginTop: '12px',
    },
  },
  menuItem: {
    padding: '8px 8px 8px 6px' + '!important',
    fontSize: '14px' + '!important',
    fontWeight: 400,
    lineHeight: '20px' + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    marginBottom: '4px' + '!important',
    '&:hover, &.Mui-selected': {
      backgroundColor: STYLE.COLOR.BACKGROUND_LIGHT + '!important',
      borderRadius: theme.spacing(1) + '!important',
    },
    '& svg': {
      marginRight: '8px',
      fontSize: '18px',
      color: STYLE.COLOR.TEXT2,
      width: '18px',
      height: '18px',
    },
  },

  // Filter Menu styles
  filterMenu: {
    '& .MuiPaper-root': {
      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
      border: `1px solid ${STYLE.COLOR.STROKE_DEFAULT}`,
      borderRadius: theme.spacing(1),
      width: '400px',
      maxWidth: '400px',
      padding: '20px',
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
      marginTop: '8px',
      '@media (max-width: 480px)': {
        width: 'calc(100vw - 32px)',
        maxWidth: 'calc(100vw - 32px)',
        margin: '0 auto',
        padding: '12px',
        position: 'fixed !important',
        left: '50% !important',
        transform: 'translateX(-50%) !important',
        right: 'auto !important',
        top: '10vh !important',
        bottom: 'auto !important',
        maxHeight: '72vh',
      },
    },
  },
  filterHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    '@media (max-width: 480px)': {
      flexDirection: 'column',
      alignItems: 'flex-start',
      gap: theme.spacing(1),
    },
  },
  filterTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: STYLE.COLOR.TEXT1,
  },
  filterActions: {
    display: 'flex',
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    alignItems: 'center',
    flex: 1,
    width: '100%',
    paddingRight: '8px',
  },
  filterAction: {
    fontSize: '12px',
    fontWeight: 500,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    cursor: 'pointer',
    whiteSpace: 'nowrap',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  searchBox: {
    marginBottom: theme.spacing(2),
    '& .MuiOutlinedInput-root': {
      borderRadius: '8px',
    },
    '@media (max-width: 480px)': {
      flex: '0 0 auto',
    },
  },
  filterOptions: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    maxHeight: '350px',
    overflowY: 'auto',
    overflowX: 'hidden',
    paddingRight: theme.spacing(1),
    '@media (max-width: 480px)': {
      flex: '1 1 auto',
      maxHeight: '60vh',
      paddingRight: theme.spacing(0),
      // ensure the options area is scrollable internally
      overflowY: 'auto',
    },
    '&::-webkit-scrollbar': {
      width: '6px',
    },
    '&::-webkit-scrollbar-track': {
      background: STYLE.COLOR.BACKGROUND_LIGHT,
      borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: STYLE.COLOR.TEXT3,
      borderRadius: '3px',
      '&:hover': {
        background: STYLE.COLOR.TEXT2,
      },
    },
  },
  filterOption: {
    margin: 0,
    padding: '8px 0',
    width: '100%',
    alignItems: 'flex-start',
    '& .MuiCheckbox-root': {
      padding: '8px',
      alignSelf: 'flex-start',
    },
    '& .MuiFormControlLabel-label': {
      width: '100%',
      overflow: 'hidden',
    },
  },
  filterOptionLabel: {
    fontSize: '14px',
    fontWeight: 400,
    color: STYLE.COLOR.TEXT1,
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    wordBreak: 'break-word',
    width: '100%',
  },
  emptySearchState: {
    padding: theme.spacing(3),
    textAlign: 'center',
    color: STYLE.COLOR.TEXT2,
    fontSize: '14px',
  },

  // Empty state styles
  emptyState: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(8, 2),
    textAlign: 'center',
    minHeight: '400px',
  },
  emptyStateIcon: {
    fontSize: '64px',
    marginBottom: theme.spacing(2),
    opacity: 0.5,
  },
  emptyStateTitle: {
    fontWeight: 600,
    color: STYLE.COLOR.TEXT1,
    marginBottom: theme.spacing(1) + '!important',
  },
  emptyStateSubtitle: {
    color: STYLE.COLOR.TEXT2,
    maxWidth: '400px',
  },
  content: {
    paddingBottom: theme.spacing(2),
  },
  paginationWrapper: {
    padding: theme.spacing(2, 0),
    marginTop: '48px',
    marginBottom: '48px',
    '@media (max-width: 768px)': {
      marginTop: '32px',
      marginBottom: '32px',
    },
    '@media (max-width: 480px)': {
      marginTop: '24px',
      marginBottom: '24px',
      '& .MuiPagination-ul': {
        flexWrap: 'nowrap',
        justifyContent: 'center',
      },
    },
  },

  // Dropdown styles for mobile
  tabDropdown: {
    flex: 1 + '!important',
    padding: '14px 16px' + '!important',
    '& .MuiSelect-icon': {
      top: 'calc(50% - 3px)' + '!important',
      right: '16px' + '!important',
    },
  },
  dropdownMenuItem: {
    padding: '12px 16px' + '!important',
    fontSize: '16px' + '!important',
    fontWeight: 400 + '!important',
    color: STYLE.COLOR.TEXT1 + '!important',
    '&.Mui-selected': {
      backgroundColor: STYLE.COLOR.ACCENT_PRIMARY + '!important',
      color: STYLE.COLOR.WHITE + '!important',
      '&:hover': {
        backgroundColor: STYLE.COLOR.ACCENT_PRIMARY + '!important',
      },
      '& .MuiBox-root.dropdownCountBadge': {
        backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3 + '!important',
        color: STYLE.COLOR.ACCENT_PRIMARY + '!important',
      },
    },
    '@media (max-width: 480px)': {
      fontSize: '14px' + '!important',
      padding: '10px 12px' + '!important',
    },
  },
  dropdownItemContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    gap: theme.spacing(1),
  },
  dropdownCountBadge: {
    backgroundColor: STYLE.COLOR.ACCENT_PRIMARY_LIGHTER3,
    color: STYLE.COLOR.ACCENT_PRIMARY,
    borderRadius: '50%',
    minWidth: '24px',
    height: '24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '10px',
    fontWeight: 600,
    lineHeight: 1,
  },
}));
